export default "__VITE_ASSET__Ctd0BwO0__"